import { Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import { ReactElement, useCallback } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import * as yup from 'yup';

interface initalValuesProps {
  id?: number | string;
  queueName?: string;
  code?: string;
  description?: string;
}

interface Props {
  title: string;
  onCancel: () => void;
  onOk: (form?: initalValuesProps) => void;
  children?: ReactElement;
  disabled?: boolean;
  forminitialValues?: initalValuesProps;
  isEdit?: boolean;
}

const validationSchema = yup.object({
  id: yup.string().notRequired(),
  queueName: yup.string().required('Il node coda è obbligatorio'),
  code: yup.string().required('Il campo è obbligatorio'),
  description: yup.string().required('La descrizione è obbligatorio'),
});

const TypeDestinationForm = ({
  title,
  onCancel,
  disabled = false,
  forminitialValues,
  onOk,
  isEdit,
}: Props): React.ReactElement => {
  const onSubmit = useCallback(
    (formValues) => {
      onOk(formValues);
    },
    [onOk]
  );

  const typeDestinationForm = useFormik({
    initialValues: forminitialValues || {
      code: '',
      description: '',
      queueName: '',
    },
    validationSchema: validationSchema,
    onSubmit,
    enableReinitialize: true,
  });
  return (
    <>
      <Card raised className="pmi-my-3">
        <form onSubmit={typeDestinationForm.handleSubmit}>
          <CardContent style={{ padding: '24px' }}>
            <Typography gutterBottom variant="h5" component="h2">
              {title}
            </Typography>
            <div style={{ padding: '24px 0 0 0' }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    label="Codice *"
                    id="code"
                    name="code"
                    fullWidth
                    type="text"
                    disabled={disabled || isEdit}
                    value={typeDestinationForm.values.code}
                    onChange={typeDestinationForm.handleChange}
                    error={
                      Boolean(typeDestinationForm.errors.code) && typeDestinationForm.touched.code
                    }
                    helperText={typeDestinationForm.errors.code}
                    variant="outlined"
                    inputProps={{
                      maxLength: '5',
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <PmiTextField
                    label="Descrizione *"
                    id="description"
                    name="description"
                    disabled={disabled}
                    value={typeDestinationForm.values.description}
                    onChange={typeDestinationForm.handleChange}
                    error={
                      Boolean(typeDestinationForm.errors.description) &&
                      typeDestinationForm.touched.description
                    }
                    helperText={typeDestinationForm.errors.description}
                    fullWidth
                    type="text"
                    variant="outlined"
                    inputProps={{
                      maxLength: '100',
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    label="Nome Coda *"
                    id="nomeCoda"
                    name="queueName"
                    disabled={disabled}
                    value={typeDestinationForm.values.queueName}
                    onChange={typeDestinationForm.handleChange}
                    error={
                      Boolean(typeDestinationForm.errors.queueName) &&
                      typeDestinationForm.touched.queueName
                    }
                    helperText={typeDestinationForm.errors.queueName}
                    fullWidth
                    type="text"
                    variant="outlined"
                    inputProps={{
                      maxLength: '100',
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </CardContent>
          <CardActions style={{ padding: '24px 24px 16px 24px' }}>
            {!disabled ? (
              <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
                Conferma
              </PmiButton>
            ) : null}
            <PmiButton variant="outlined" color="cdmBrand" onClick={onCancel}>
              Indietro
            </PmiButton>
          </CardActions>
        </form>
      </Card>
    </>
  );
};

TypeDestinationForm.displayName = 'Types Destination form component';
export default TypeDestinationForm;
